window.workspaceTheme = (function ($, window, document) {
  function hexToRgbTriplet(hex) {
    hex = hex.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    return `${r} ${g} ${b}`;
  }

  function rgbToHex(rgbString) {
    const parts = rgbString.trim().split(/\s+/);
    if (parts.length !== 3) return null;
    return `#${parts.map(c => {
      const hex = parseInt(c, 10).toString(16).toUpperCase();
      return hex.length === 1 ? `0${hex}` : hex;
    }).join('')}`;
  }

  const EMPLOYEE_SCHEDULE_NAVBAR_DEFAULT_BG = '#37C2DE';

  function updatePreviewColor(colorName, hexValue) {
    const preview = document.getElementById('theme_preview');
    if (!preview) return;
    preview.style.setProperty(`--ui-color-${colorName}`, hexToRgbTriplet(hexValue));
  }

  function removePreviewColor(colorName) {
    const preview = document.getElementById('theme_preview');
    if (!preview) return;
    preview.style.removeProperty(`--ui-color-${colorName}`);
  }

  function updateEmployeeScheduleNavbar(hexValue) {
    const navbar = document.getElementById('employee_schedule_navbar');
    if (navbar) navbar.style.backgroundColor = hexValue;
  }

  function showResetButton(colorName, mode) {
    const btn = document.getElementById(`reset_btn_${colorName}_${mode}`);
    if (btn) btn.classList.remove('hidden');
  }

  function resetColor(colorName, mode) {
    const hiddenField = document.getElementById(`workspace_${colorName}_color_${mode}`);
    const picker = document.querySelector(`input[type="color"][data-color-name="${colorName}"][data-color-mode="${mode}"]`);
    const resetBtn = document.getElementById(`reset_btn_${colorName}_${mode}`);
    const form = document.getElementById('theme_preview_form');
    const nullableColors = JSON.parse(form.dataset.nullableColors);
    const isNullable = nullableColors.includes(colorName);

    if (hiddenField) hiddenField.value = '';
    if (resetBtn) resetBtn.classList.add('hidden');

    if (isNullable) {
      if (picker) {
        picker.value = '#000000';
        picker.classList.add('color-swatch--null');
      }
      if (mode === 'light') {
        removePreviewColor(colorName);
      }
      if (colorName === 'navigation' && mode === 'dark') {
        updateEmployeeScheduleNavbar(EMPLOYEE_SCHEDULE_NAVBAR_DEFAULT_BG);
      }
    } else if (mode === 'light') {
      const defaultHex = rgbToHex(getComputedStyle(document.documentElement).getPropertyValue(`--ui-color-${colorName}`));
      if (picker && defaultHex) picker.value = defaultHex;
      removePreviewColor(colorName);
    } else {
      if (picker) {
        picker.value = '#000000';
        picker.classList.add('color-swatch--null');
      }
    }
  }

  // fieldName is e.g. "icon_light", "icon_dark", "logo_light", "logo_dark"
  // hiddenFieldName derives the removal hidden field name e.g. "icon_url_light"
  function hiddenFieldName(fieldName) {
    const parts = fieldName.split('_');
    return `${parts[0]}_url_${parts[1]}`;
  }

  function handleImageSelected(input, fieldName) {
    const preview = document.getElementById(`${fieldName}_preview`);
    if (input.files && input.files[0]) {
      const reader = new FileReader();
      reader.onload = function (e) {
        preview.src = e.target.result;
        document.getElementById(`${fieldName}_present`).classList.remove('hidden');
        document.getElementById(`${fieldName}_input`).classList.add('hidden');
        if (fieldName === 'logo_light') {
          const themeLogo = document.getElementById('theme_preview_logo');
          if (themeLogo) themeLogo.src = e.target.result;
          const employeeLogo = document.getElementById('employee_preview_logo');
          if (employeeLogo) employeeLogo.src = e.target.result;
        }
        if (fieldName === 'logo_dark') {
          const empScheduleLogo = document.getElementById('employee_schedule_preview_logo');
          if (empScheduleLogo) empScheduleLogo.src = e.target.result;
        }
        if (fieldName === 'icon_light') {
          const themeIcon = document.getElementById('theme_preview_icon');
          if (themeIcon) themeIcon.src = e.target.result;
        }
      };
      reader.readAsDataURL(input.files[0]);
    }
  }

  function chooseNewImage(fieldName) {
    document.getElementById(`remove_${hiddenFieldName(fieldName)}`).value = '1';
    document.getElementById(`${fieldName}_present`).classList.add('hidden');
    document.getElementById(`${fieldName}_input`).classList.remove('hidden');
  }

  function removeImage(fieldName) {
    document.getElementById(`remove_${hiddenFieldName(fieldName)}`).value = '1';
    document.getElementById(`${fieldName}_present`).classList.add('hidden');
    document.getElementById(`${fieldName}_input`).classList.remove('hidden');
    if (fieldName === 'logo_light') {
      const themeLogo = document.getElementById('theme_preview_logo');
      if (themeLogo) themeLogo.src = themeLogo.dataset.defaultSrc;
      const employeeLogo = document.getElementById('employee_preview_logo');
      if (employeeLogo) employeeLogo.src = employeeLogo.dataset.defaultSrc;
    }
    if (fieldName === 'logo_dark') {
      const empScheduleLogo = document.getElementById('employee_schedule_preview_logo');
      if (empScheduleLogo) empScheduleLogo.src = empScheduleLogo.dataset.defaultSrc;
    }
    if (fieldName === 'icon_light') {
      const themeIcon = document.getElementById('theme_preview_icon');
      if (themeIcon) themeIcon.src = themeIcon.dataset.defaultSrc;
    }
  }

  function initializeColorPickers() {
    const style = getComputedStyle(document.documentElement);
    const form = document.getElementById('theme_preview_form');
    const colorNames = JSON.parse(form.dataset.colorNames);
    const nullableColors = JSON.parse(form.dataset.nullableColors);

    colorNames.forEach(name => {
      const isNullable = nullableColors.includes(name);
      const hex = rgbToHex(style.getPropertyValue(`--ui-color-${name}`));

      // Initialize light picker — nullable colors stay null, others fall back to CSS variable
      const lightField = document.getElementById(`workspace_${name}_color_light`);
      if (lightField && !lightField.value) {
        if (!isNullable && hex) {
          lightField.setAttribute('placeholder', hex);
          const lightPicker = document.querySelector(`input[type="color"][data-color-name="${name}"][data-color-mode="light"]`);
          if (lightPicker) lightPicker.value = hex;
        }
      }

      // Initialize dark picker — sync with saved value
      const darkField = document.getElementById(`workspace_${name}_color_dark`);
      if (darkField && darkField.value) {
        const darkPicker = document.querySelector(`input[type="color"][data-color-name="${name}"][data-color-mode="dark"]`);
        if (darkPicker) darkPicker.value = darkField.value;
      }
    });
  }

  function initializePreview() {
    document.querySelectorAll('input[type="color"][data-color-name][data-color-mode="light"]').forEach(picker => {
      const colorName = picker.dataset.colorName;
      const hiddenField = document.getElementById(`workspace_${colorName}_color_light`);
      if (!hiddenField || !hiddenField.value) return;
      updatePreviewColor(colorName, picker.value);
    });
  }

  const init = function () {
    $(document).on('change', '#theme_preview_form input[type="color"][data-color-name]', function () {
      const colorName = this.dataset.colorName;
      const mode = this.dataset.colorMode || 'light';
      const hiddenField = document.getElementById(`workspace_${colorName}_color_${mode}`);
      if (hiddenField) hiddenField.value = this.value.toUpperCase();

      // Only update preview for light mode pickers (preview shows light mode only)
      if (mode === 'light') {
        updatePreviewColor(colorName, this.value);
      }

      if (colorName === 'navigation' && mode === 'dark') {
        updateEmployeeScheduleNavbar(this.value);
      }

      this.classList.remove('color-swatch--null');
      showResetButton(colorName, mode);
    });

    $(document).on('click', '#theme_preview_form [data-action="reset-color"]', function () {
      resetColor(this.dataset.colorName, this.dataset.colorMode);
    });

    $(document).on('click', '#theme_preview_form [data-action="choose-image"]', function () {
      chooseNewImage(this.dataset.field);
    });

    $(document).on('click', '#theme_preview_form [data-action="remove-image"]', function () {
      removeImage(this.dataset.field);
    });

    $(document).on('change', '#theme_preview_form input[type="file"][data-field]', function () {
      handleImageSelected(this, this.dataset.field);
    });

    initializeColorPickers();
    initializePreview();
  };

  return { init: init, hexToRgbTriplet };

})(jQuery, window, document);
